import React, { FunctionComponent } from 'react'
import { Card, Form, Input, Space } from 'antd'
import AgencySelect from '../../../components/FormItems/AgencySelect'
import { Vehicle } from 'server'

interface IProps {
  setSelectedAgency: (value: number) => void
  setSearch: (value: string) => void
  vehicles: Vehicle[]
}

const DevicesListFilter: FunctionComponent<any> = (props: IProps) => {
  const { setSelectedAgency, setSearch, vehicles } = props

  const handleAgencyChange = (value: number) => {
    setSelectedAgency(value)
  }

  const handleSearch = (value: string) => {
    setSearch(value)
  }

  const handleSearchInput = (e: any) => {
    const { value } = e.target
    setSearch(value)
  }

  return (
    <Card>
      <Form layout={'vertical'}>
        <Space direction={'vertical'} style={{ width: '100%' }}>
          <Form.Item name={'search'} style={{ margin: 0, width: '100%' }}>
            <Input.Search
              allowClear={true}
              placeholder={'Search by Unit Name or Asset ID'}
              onSearch={handleSearch}
              onInput={handleSearchInput}
            />
          </Form.Item>
          <AgencySelect vehicles={vehicles} onChange={handleAgencyChange} />
        </Space>
      </Form>
    </Card>
  )
}

export default DevicesListFilter
